module.exports = __webpack_public_path__ + "static/media/map_world_map.14e136bf.png";